import Navigation from './components/Navigations/Navigation';

function App() {
  return (
    <div>
      <Navigation />
    </div>

  );
}

export default App;
